/** Region UUIDs — keep in sync with api/src/common/Regions.js */
export const PRE_ASSIGNMENT_REGIONS = {
  en_US: 'c10342aa-0c44-41c6-9b50-cf401c7244a9',
  en_CA: '0b3d248d-3843-47f2-b1c5-6d033b0c51b8',
  fr_CA: 'fb12f06b-4c8f-4bfd-b410-5c835f35feca',
};

const SIZE_BASED_ASSIGN_UI_REGION_IDS = [
  PRE_ASSIGNMENT_REGIONS.en_CA,
  PRE_ASSIGNMENT_REGIONS.fr_CA,
];

export const isTruthyPreAssignmentFlag = (value) =>
  [true, 'true', 1, '1'].includes(value);

export const isPreAssignmentAccountFromSession = () =>
  isTruthyPreAssignmentFlag(sessionStorage.getItem('is_pre_assignment'));

/**
 * Box selected_regioin (POS / Global Payments region) drives assign UI variant:
 * en_CA / fr_CA → bin size + PreAssignmentLayout; other regions → bin ID + full map.
 */
export const isSizeBasedAssignUIRegion = (regionId) =>
  !!(regionId && SIZE_BASED_ASSIGN_UI_REGION_IDS.includes(regionId));

export const resolveSizeBasedAssignUIFromBox = (box) =>
  isSizeBasedAssignUIRegion(box && box.selected_regioin);

/** @deprecated use isSizeBasedAssignUIRegion */
export const isSizeBasedPreAssignmentRegion = isSizeBasedAssignUIRegion;

/** @deprecated use resolveSizeBasedAssignUIFromBox */
export const resolveSizeBasedPreAssignmentFromBox = resolveSizeBasedAssignUIFromBox;

const pickBinCount = (data, camelKey, lowerKey) => {
  if (!data) {
    return 0;
  }
  const camel = data[camelKey];
  if (camel !== undefined && camel !== null && camel !== '') {
    return Number(camel);
  }
  const lower = data[lowerKey];
  if (lower !== undefined && lower !== null && lower !== '') {
    return Number(lower);
  }
  return 0;
};

/** Normalize getAvailableBinsCount API payload (pg may return lowercase keys). */
export const parseAvailableBinCounts = (data) => {
  if (!data) {
    return {
      xSmallCounts: 0,
      largeCounts: 0,
      mediumCounts: 0,
      smallCounts: 0,
      mediumWideCounts: 0,
      slimWideCounts: 0,
      largeWideCounts: 0,
      extraLargeCounts: 0,
      coolCounts: 0,
    };
  }
  const extraLargeCounts =
    pickBinCount(data, 'extraLargeCounts', 'extralargecounts') ||
    pickBinCount(data, 'coolCounts', 'coolcounts');
  return {
    xSmallCounts: pickBinCount(data, 'xSmallCounts', 'xsmallcounts'),
    largeCounts: pickBinCount(data, 'largeCounts', 'largecounts'),
    mediumCounts: pickBinCount(data, 'mediumCounts', 'mediumcounts'),
    smallCounts: pickBinCount(data, 'smallCounts', 'smallcounts'),
    mediumWideCounts: pickBinCount(data, 'mediumWideCounts', 'mediumwidecounts'),
    slimWideCounts: pickBinCount(data, 'slimWideCounts', 'slimwidecounts'),
    largeWideCounts: pickBinCount(data, 'largeWideCounts', 'largewidecounts'),
    extraLargeCounts,
    coolCounts: extraLargeCounts,
  };
};

export {
  BIN_SIZE_CODE_TO_LABEL,
  BIN_SIZE_SHORT_LABEL,
  PORTAL_BRAND_ACCENT_GREEN,
  SIZE_BASED_ASSIGN_BIN_SIZES,
  LEGACY_ASSIGN_BIN_SIZES,
  resolveBinSizeLabel,
  parseSizeBasedBinCounts,
  getBinSizeTranslationMap,
} from './binSizes';



// WEBPACK FOOTER //
// ./src/utils/preAssignment.js